import AutomationRulesTab from 'modules/funnels/funnel/components/funnel-rules/components/automation-rules-tab'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import type { JSX } from 'react'
import DeadlineSettingsTab from '../components/deadline-settings-tab/deadline-settings-tab'
import EmailTab from '../components/email-tab/email-tab'
import LeadsTab from '../components/leads-tab/leads-tab'
import PageTemplateSelector from '../components/page-template-selector'
import SalesTab from '../components/sales-tab/components/sales-tab'
import SplitTestsTab from '../components/split-tests-tab/split-tests-tab'
import StatisticsTab from '../components/statistics-tab/statistics-tab'
import StepConfigurationTab from '../components/step-configuration-tab'
import { FunnelStepSettingTabsEnum } from '../enums/funnel-step-setting-tabs-enum'
import { FunnelStepInterface } from '../types/funnel-step-interface'

export const getFunnelStepSettingTabContent = (
  funnelId: FunnelId,
  funnelStep: FunnelStepInterface,
  activeTab?: FunnelStepSettingTabsEnum | null,
): JSX.Element => {
  if (!funnelStep.page) {
    return <PageTemplateSelector funnelId={funnelId} funnelStep={funnelStep} />
  }

  switch (activeTab) {
    case FunnelStepSettingTabsEnum.stepConfiguration: {
      return <StepConfigurationTab funnelId={funnelId} funnelStep={funnelStep} />
    }
    case FunnelStepSettingTabsEnum.automationRules: {
      return <AutomationRulesTab funnelId={funnelId} funnelStepId={funnelStep.id} />
    }
    case FunnelStepSettingTabsEnum.tests: {
      return <SplitTestsTab funnelId={funnelId} funnelStep={funnelStep} />
    }
    case FunnelStepSettingTabsEnum.leads: {
      return <LeadsTab funnelId={funnelId} />
    }
    case FunnelStepSettingTabsEnum.stats: {
      return <StatisticsTab funnelId={funnelId} />
    }
    case FunnelStepSettingTabsEnum.sales: {
      return <SalesTab funnelId={funnelId} />
    }
    case FunnelStepSettingTabsEnum.emails: {
      return <EmailTab funnelStepId={funnelStep.id} />
    }
    case FunnelStepSettingTabsEnum.deadlineSettings: {
      return <DeadlineSettingsTab funnelId={funnelId} />
    }
    default: {
      return <></>
    }
  }
}
